import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormlyTemplateOptions} from "@ngx-formly/core";

@Component({
    selector: 'app-weave-repeater',
    templateUrl: './weave-repeater.component.html',
    styleUrls: ['./weave-repeater.component.scss'],
    standalone: false
})
export class WeaveRepeaterComponent implements OnInit {

  @Input() fields: repeaterField[];
  @Input() initialValues: any = [];
  @Input() hasAtLeastOneRow: boolean = false;
  @Input() showErrors: boolean = false;
  @Output() valuesEmitter = new EventEmitter<any>();
  values: any;

  readonly Object = Object;

  constructor() {
  }

  ngOnInit() {
    this.values = this.initialValues;
    if (this.initialValues.length == 0 && this.hasAtLeastOneRow) {
      this.addRow(false);
    }
  }

  addRow(emitValues = true) {
    let newObj = {};
    for (let field of this.fields) {

      if (field.type == 'checkbox') {
        newObj[field.propertyName] = [];
      } else {
        newObj[field.propertyName] = field.defaultValue ? field.defaultValue : "";
      }

    }
    this.values.push(newObj);
    if (emitValues) {
      this.valuesEmitter.emit(this.values);
    }
  }

  removeRow(index: number) {
    this.values.splice(index, 1);
    this.valuesEmitter.emit(this.values);
  }

  emitValues(valueRow, propertyName, val) {
    valueRow[propertyName] = val;
    this.valuesEmitter.emit(this.values);
  }
}

export interface repeaterField {
  label: string,
  type: string,
  propertyName: string,
  defaultValue?: string,
  selectValues?: {
    label: string,
    value: any
  }[],
  templateOptions?: FormlyTemplateOptions,
  placeholder?: string,
  required?: boolean
}
